import type { TextCarouselBannerModel } from "src/features/HomepageCarouselBanners/models";
import type { ReactNode } from "react";

import { Fragment } from "react";

export interface TextCarouselBannerProps extends Partial<TextCarouselBannerModel> {}

const TextCarouselBanner = ({
	backgroundColor,
	foregroundColor,
	headingText,
	subheadingText,
	showPlaceholder = true
}: TextCarouselBannerProps & { showPlaceholder?: boolean }) => {
	const renderPlaceholder = (children: ReactNode) => {
		if (!showPlaceholder) return null;

		return children;
	};

	return (
		<div
			className="w-full flex items-center"
			style={{
				aspectRatio: 16 / 9,
				backgroundColor: backgroundColor ?? "#E0E0E0"
			}}
		>
			<div className="flex w-full flex-col gap-1 px-6">
				{headingText ? (
					<p
						className="text-2xl font-bold leading-tight"
						style={{ color: foregroundColor ?? "white" }}
					>
						{headingText}
					</p>
				) : (
					renderPlaceholder(
						<Fragment>
							<div
								className="bg-white rounded-[65px] h-[5px] w-4/5"
								data-testid="heading-text-placeholder"
							/>
							<div className="bg-white rounded-[65px] h-[5px] w-full" />
							<div className="bg-white rounded-[65px] h-[5px] w-[90%]" />
							<div className="bg-white rounded-[65px] h-[5px] w-[90%]" />
						</Fragment>
					)
				)}

				{subheadingText ? (
					<p
						className="text-base opacity-80"
						style={{ color: foregroundColor ?? "white" }}
					>
						{subheadingText}
					</p>
				) : (
					renderPlaceholder(
						<div
							className="bg-white rounded-[65px] h-[5px] w-[30%]"
							data-testid="subheading-text-placeholder"
						/>
					)
				)}
			</div>
		</div>
	);
};

export default TextCarouselBanner;
